exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-pills .nav-link.active{background-color:#41b883}.nav-pills .nav-link.active a{color:#000;text-decoration:none}a:hover{text-decoration:none;font-weight:700;color:#41b883}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0746d28c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 25
// module chunks = 0